import React from "react";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <p>
        &copy; {currentYear} Agnieszka Jeżyna-Matraszek - Korepetycje z Matematyki. Wszelkie
        prawa zastrzeżone.
      </p>
    </footer>
  );
}

export default Footer;